import InputSimple from './InputSimple';
export { default as nameDecorator } from './decorators/nameDecorator';
export { default as phoneDecorator } from './decorators/phoneDecorator';

export default InputSimple;
